export const GET_DATA = "GET_DATA";
export const FILTER_DATA = "FILTER_DATA";

export const USER_EMAIL = "USER_EMAIL";